<template>
  <div class="houseDetail">
    <section
      v-for="(item, index) in createHouseItemRequestDtos"
      :key="index"
      class="sectionClass"
    >
      <div class="homeEdit">
        <div class="homeName">
          <img src="../../assets/images/houseImage.svg">
          <b-form-input
            v-if="item.editable"
            v-model="item.name"
            type="text"
            class="editInput"
            @blur="saveHouseName(index)"
            @keydown.enter="saveHouseName(index)"
          />
          <span v-else>{{ item.name }}</span>
        </div>
        <div class="iconsClass">
          <img
            v-if="!item.editable"
            style="cursor:pointer;width:20px;"
            src="../../assets/images/PenIcon.svg"
            @click="toggleEditHouseName(index)"
          >
          <b-icon-check-circle
            v-if="item.editable"
            style="cursor:pointer;width:20px;"
            @click="toggleEditHouseName(index)"
          />
          <img
            src="../../assets/images/Trash_Full.svg"
            style="cursor:pointer;;width:20px;"
            @click="removeHouse(index)"
          >
          <button
            v-if="item.createFloorRequestDtos.length == 0"
            class="buttonNotaSmall"
            type="button"
            @click="addFloor(index)"
          >
            Shto Katin e ri
          </button>
          <b-button
            variant="link"
            class="collapse-button"
            @click="toggleCollapse(index)"
          >
            <b-icon-chevron-down v-if="!isCollapsed(index)" />
            <b-icon-chevron-up v-if="isCollapsed(index)" />
          </b-button>
        </div>
      </div>
      <p
        v-if="item.createFloorRequestDtos.length == 0 && isButtonSubmited "
        class="validationClass"
      >
        {{ $t('Please select a floor') }}
      </p>
      <b-collapse :visible="!isCollapsed(index)">
        <hr
          v-if="item.createFloorRequestDtos.length > 0"
          class="hrClass"
        >
        <div :class="isCollapsedFloor(index) ? 'buttonOnly' : 'buttonAndCollapse'">
          <p
            v-if="isCollapsedFloor(index)"
            style="margin: 0px;font-weight: 600"
          >
            Floor closed
          </p>
          <b-collapse
            :visible="!isCollapsedFloor(index)"
          >
            <div class="allClases">
              <div
                v-for="(floor, floorIndex) in item.createFloorRequestDtos"
                :key="floorIndex"
                class="floorWrapper"
              >
                <button
                  v-b-tooltip.hover
                  class="objectsClass"
                  :title="floor.name"
                  type="button"
                  :class="{ 'selectedFloor': selectedFloorIndex === floorIndex }"
                  @click="selectFloorToAddRoom(index, floorIndex)"
                >
                  <span class="iconsFloor">
                    <img
                      v-if="!floor.editable"
                      style="cursor:pointer"
                      src="../../assets/images/PenIcon.svg"
                      @click="toggleEditFloorName(index, floorIndex)"
                    >
                    <b-icon-check-circle
                      v-if="floor.editable"
                      @click="toggleEditFloorName(index, floorIndex)"
                    />
                    <img
                      src="../../assets/images/Trash_Full.svg"
                      style="cursor:pointer;"
                      @click="removeFloor(index, floorIndex)"
                    >
                  </span>
                  <span class="nameFloor">
                    <img
                      src="../../assets/images/HomeImage.svg"
                      style="height: 40px;"
                    >
                    <b-form-input
                      v-if="floor.editable"
                      v-model="floor.name"
                      type="text"
                      class="editInput"
                      style="width:100px"
                      @blur="saveFloorName(index, floorIndex)"
                      @keydown.enter="saveFloorName(index, floorIndex)"
                    />
                    <span v-else>{{ floor.name }}</span>
                  </span>
                </button>
              </div>
              <div v-if="item.createFloorRequestDtos.length > 0">
                <button
                  class="buttonNota"
                  type="button"
                  @click="addFloor(index)"
                >
                  <p style="font-size: 12px;margin-bottom:0px;padding:0px 3px 0px 3px;">
                    Shto Katin e ri
                  </p>
                </button>
              </div>

            </div>
          </b-collapse>
          <div
            v-if="item.createFloorRequestDtos.length > 0"
            class="buttonsCollapsed"
          >
            <b-button
              variant="link"
              class="collapse-button"
              @click="toggleCollapseFloor(index)"
            >
              <b-icon-chevron-down v-if="!isCollapsedFloor(index)" />
              <b-icon-chevron-up v-if="isCollapsedFloor(index)" />
            </b-button>
          </div>
        </div>
        <hr
          v-if="item.createFloorRequestDtos.length > 0"
          class="hrClass"
        >
        <div :class="isCollapsedRoom(index) ? 'buttonOnly' : 'buttonAndCollapse'">
          <p
            v-if="isCollapsedRoom(index)"
            style="margin: 0px;font-weight: 600"
          >
            Room closed
          </p>
          <b-collapse
            :visible="!isCollapsedRoom(index)"
          >
            <div class="allClases">
              <div
                v-for="(room, roomIndex) in item.createFloorRequestDtos[selectedFloorIndex]?.createRoomRequestDtos"
                :key="roomIndex"
                class="floorWrapper"
              >
                <button
                  v-b-tooltip.hover
                  class="objectsClass"
                  :title="room.name"
                  type="button"
                  :class="{ 'selectedFloor': selectedRoomIndex === roomIndex }"
                  @click="selectRoomToAddObject(index, selectedFloorIndex, roomIndex)"
                >
                  <span class="iconsFloor">
                    <img
                      v-if="!room.editable"
                      style="cursor:pointer"
                      src="../../assets/images/PenIcon.svg"
                      @click="toggleEditRoomName(index, selectedFloorIndex, roomIndex)"
                    >
                    <b-icon-check-circle
                      v-if="room.editable"
                      @click="toggleEditRoomName(index, selectedFloorIndex, roomIndex)"
                    />
                    <img
                      src="../../assets/images/Trash_Full.svg"
                      style="cursor:pointer;"
                      @click="removeRoom(index, selectedFloorIndex, roomIndex)"
                    >
                  </span>
                  <span class="nameFloor">
                    <img
                      src="../../assets/images/RoomImage.svg"
                      style="height: 40px;"
                    >
                    <b-form-input
                      v-if="room.editable"
                      v-model="room.name"
                      type="text"
                      class="editInput"
                      style="width:100px"
                      @blur="saveRoomName(index, selectedFloorIndex, roomIndex)"
                      @keydown.enter="saveRoomName(index, selectedFloorIndex, roomIndex)"
                    />
                    <span v-else>{{ room.name }}</span>
                  </span>
                </button>
              </div>
              <div
                v-if="item.createFloorRequestDtos.length > 0"
              >
                <button
                  class="buttonNota"
                  type="button"
                  @click="addRoom(index, selectedFloorIndex)"
                >
                  <p style="font-size: 12px;margin-bottom:0px;padding:0px 3px 0px 3px;">
                    Shto Dhomen e re
                  </p>
                </button>

              </div>
            </div>
          </b-collapse>
          <div
            v-if="item.createFloorRequestDtos.length > 0"
            class="buttonsCollapsed"
          >
            <b-button
              variant="link"
              class="collapse-button"
              @click="toggleCollapseRoom(index)"
            >
              <b-icon-chevron-down v-if="!isCollapsedRoom(index)" />
              <b-icon-chevron-up v-if="isCollapsedRoom(index)" />
            </b-button>
          </div>
        </div>
        <p
          v-if="item.createFloorRequestDtos[selectedFloorIndex]?.createRoomRequestDtos.length == 0 && isButtonSubmited "
          class="validationClass"
        >
          {{ $t('Please select a room') }}
        </p>
        <hr
          v-if="item.createFloorRequestDtos.length > 0"
          class="hrClass"
        >
        <div :class="isCollapsedObject(index) ? 'buttonOnly' : 'buttonAndCollapse'">
          <p
            v-if="isCollapsedObject(index)"
            style="margin: 0px;font-weight: 600"
          >
            Object closed
          </p>
          <b-collapse
            :visible="!isCollapsedObject(index)"
          >
            <div class="allClases">
              <div
                v-for="(window, windowIndex) in item.createFloorRequestDtos[selectedFloorIndex]?.createRoomRequestDtos[selectedRoomIndex]?.createWindowRequestDtos"
                :key="windowIndex"
                class="floorWrapper"
              >
                <button
                  v-b-tooltip.hover
                  class="objectsClass"
                  :title="window.name"
                  type="button"
                  :class="{ 'selectedFloor': selectedWindowIndex === windowIndex }"
                  @click="selectWindowToObject(index, selectedFloorIndex, selectedRoomIndex, windowIndex)"
                >
                  <span class="iconsFloor">
                    <img
                      v-if="!window.editable"
                      style="cursor:pointer"
                      src="../../assets/images/PenIcon.svg"
                      @click="toggleEditWindowName(index, selectedFloorIndex, selectedRoomIndex, windowIndex, window)"
                    >
                    <b-icon-check-circle
                      v-if="window.editable"
                      @click="toggleEditWindowName(index, selectedFloorIndex, selectedRoomIndex, windowIndex, window)"
                    />
                    <img
                      v-if="!window.editable"
                      src="../../assets/images/Trash_Full.svg"
                      style="cursor:pointer;"
                      @click="removeWindow(index, selectedFloorIndex, selectedRoomIndex, windowIndex)"
                    >
                  </span>
                  <span class="nameFloor">
                    <img
                      src="../../assets/images/ObjectImage.svg"
                      style="height: 40px;"
                    >
                    <b-form-input
                      v-if="window.editable"
                      v-model="window.name"
                      type="text"
                      class="editInput"
                      style="width:100px"
                      @blur="saveWindowName(index, selectedFloorIndex, selectedRoomIndex, windowIndex, window)"
                      @keydown.enter="saveWindowName(index, selectedFloorIndex, selectedRoomIndex, windowIndex, window)"
                    />
                    <span v-else>{{ window.name }}</span>
                  </span>
                </button>
              </div>
              <button
                v-if="item.createFloorRequestDtos[selectedFloorIndex]?.createRoomRequestDtos.length > 0"
                class="buttonNota"
                type="button"
                @click="addWindow(index)"
              >
                <p style="font-size: 12px;margin-bottom:0px;padding:0px 3px 0px 3px;">
                  Shto Pozicionin e ri
                </p>
              </button>
            </div>
          </b-collapse>
          <div
            v-if="item.createFloorRequestDtos[selectedFloorIndex]?.createRoomRequestDtos.length > 0"
            class="buttonsCollapsed"
          >
            <b-button
              variant="link"
              class="collapse-button"
              @click="toggleCollapseObject(index)"
            >
              <b-icon-chevron-down v-if="!isCollapsedObject(index)" />
              <b-icon-chevron-up v-if="isCollapsedObject(index)" />
            </b-button>
          </div>
        </div>
        <p
          v-if="item.createFloorRequestDtos[selectedFloorIndex]?.createRoomRequestDtos[selectedRoomIndex]?.createWindowRequestDtos.length == 0 && isButtonSubmited "
          class="validationClass"
        >
          {{ $t('Please select a object') }}
        </p>
        <div v-if="selectedWindowIndex !== null">
          <div :class="isCollapsedObjectMaterials(index) ? 'buttonOnly' : 'buttonAndCollapse'">
            <p
              v-if="isCollapsedObjectMaterials(index)"
              style="margin: 5px 0px 0px 0px;font-weight: 600"
            >
              Materials closed
            </p>
            <b-collapse
              :visible="!isCollapsedObjectMaterials(index)"
              style="width:100%"
            >
              <div
                v-for="(window, windowIndex) in item.createFloorRequestDtos[selectedFloorIndex]?.createRoomRequestDtos[selectedRoomIndex]?.createWindowRequestDtos"
                :key="windowIndex"
              >
                <div
                  v-if="windowIndex === selectedWindowIndex"
                  class="allMaterialsDetails"
                >
                  <label style="font-size: 16px;font-weight:500">{{ windowIndex + 1 }}.{{ $t('WorkingNow') }} : {{ item.name }}-{{ item.createFloorRequestDtos[selectedFloorIndex]?.name }}-{{ item.createFloorRequestDtos[selectedFloorIndex]?.createRoomRequestDtos[selectedRoomIndex]?.name }}-{{ window.name }} </label>
                  <!-- <div style="display:flex;">
                      <div class="ordersService">
                        <b-form-checkbox
                          v-model="window.orderOtherService.pattern"
                        />
                        <label style="font-size: 25px">{{ $t('InPattern') }} </label>
                      </div>
                      <div class="ordersService">
                        <b-form-checkbox
                          v-model="window.orderOtherService.sewing"
                        />
                        <label style="font-size: 25px">{{ $t('Sewing') }} </label>
                      </div>
                      <div class="ordersService">
                        <b-form-checkbox
                          v-model="window.orderOtherService.transport"
                        />
                        <label style="font-size: 25px">{{ $t('Transport') }} </label>
                      </div>
                      <div class="ordersService">
                        <b-form-checkbox
                          v-model="window.orderOtherService.montage"
                          @input="checkMontage(window.orderOtherService.montage, window)"
                        />
                        <label style="font-size: 25px">{{ $t('Montage') }} </label>
                      </div>
                    </div> -->
                  <div style="display: flex;gap:15px">
                    <b-form-group
                      :label="$t('HingType')"
                      style="width: 20%;"
                    >
                      <vue-select
                        v-model="window.hingType"
                        :options="hingeTypes"
                        label="name"
                        :reduce="(e) => e.value"
                        :placeholder="$t('Select')"
                        :multiple="true"
                        @input="updateDecorative(index, window, $event)"
                      />
                    </b-form-group>
                    <!-- <b-form-group
                        v-if="window.orderOtherService.montage == true"
                        :label="$t('MontageStart')"
                      >
                        <date-picker
                          v-model="window.montageStart"
                          type="datetime"
                          :placeholder="$t('SelectD')"
                          format="YYYY-MM-DD HH:mm"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="window.orderOtherService.montage == true"
                        :label="$t('MontageEnd')"
                      >
                        <date-picker
                          v-model="window.montageEnd"
                          type="datetime"
                          :placeholder="$t('SelectD')"
                          format="YYYY-MM-DD HH:mm"
                        />
                      </b-form-group> -->
                  </div>
                  <div style="display: flex;gap:15px">
                    <b-form-group
                      :label="$t('Width')"
                    >
                      <div class="input-wrapper">
                        <b-form-input
                          v-model.number="window.width"
                          :placeholder="$t('Type')"
                          class="custom-input"
                          min="0"
                          type="number"
                          @input="updateMaterialLengthOrQuantity(window); updateWindowDecorativeWidth(window)"
                        />
                        <span class="unitMeter">m</span>
                      </div>

                      <p
                        v-if="(window.width < 0 || window.width == null || window.width == '') && isButtonSubmited "
                        class="validationClass"
                      >
                        {{ $t('TheValue') }}
                      </p>
                    </b-form-group>
                    <b-form-group
                      :label="$t('Height')"
                    >
                      <div class="input-wrapper">
                        <b-form-input
                          v-model.number="window.height"
                          :placeholder="$t('Type')"
                          class="custom-input"
                          min="0"
                          type="number"
                          @input="updateWindowDecorativeHeight(window)"
                        />
                        <span class="unitMeter">m</span>
                      </div>

                      <p
                        v-if="(window.height < 0 || window.height == null || window.height == '') && isButtonSubmited"
                        class="validationClass"
                      >
                        {{ $t('TheValue') }}
                      </p>
                    </b-form-group>
                    <b-form-group
                      :label="$t('SewingType')"
                      style="width: 25%;"
                    >
                      <vue-select
                        v-model="window.sewingType"
                        :options="sewingTypes"
                        label="name"
                        :reduce="(e) => e.value"
                        :placeholder="$t('Select')"
                        @input="handleSewingMethod(window)"
                      />
                      <p
                        v-if="window.sewingType == null && isButtonSubmited "
                        class="validationClass"
                      >
                        {{ $t('Please select a sewing type') }}
                      </p>
                    </b-form-group>
                  </div>
                  <div
                    v-for="(material, materialIndex) in window.materialVariantInStoreDtos"
                    :key="materialIndex"
                    class="materialsClass"
                  >
                    <div style="display:flex;justify-content: space-between;">
                      <label> {{ materialIndex + 1 }}.{{ $t('MeasurementType') }} <span style="font-weight:600"> {{ material.parameter ? `: ${material.parameter}`: null }} </span></label>
                      <img
                        v-if="!material.parameter"
                        src="../../assets/images/Trash_Full.svg"
                        style="cursor:pointer;"
                        @click="removeMaterial(index, materialIndex)"
                      >
                    </div>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="material.measurementType"
                        style="display:flex;gap: 10px;width:90%"
                        :class="{'form-radio-disabled': material.parameter === 'Shirit'}"
                        :disabled="material.parameter === 'Shirit' ? true : false"
                        @change="resetMaterialName(material, window)"
                      >
                        <b-form-radio
                          class="form-radio"
                          value="Meter"
                        >
                          <p>{{ $t('Meter') }} </p>
                        </b-form-radio>
                        <b-form-radio
                          class="form-radio"
                          value="Part"
                        >
                          <p>{{ $t('Part') }} </p>
                        </b-form-radio>
                        <b-form-radio
                          class="form-radio"
                          value="Verse"
                        >
                          <p>{{ $t('Verse') }} </p>
                        </b-form-radio>
                        <b-form-radio
                          class="form-radio"
                          value="Package"
                        >
                          <p>{{ $t('Package') }} </p>
                        </b-form-radio>
                        <b-form-radio
                          class="form-radio"
                          value="Pair"
                        >
                          <p>{{ $t('Pair') }} </p>
                        </b-form-radio>
                        <b-form-radio
                          class="form-radio"
                          value="Set"
                        >
                          <p>{{ $t('Set') }} </p>
                        </b-form-radio>
                        <b-form-radio
                          class="form-radio"
                          value="Meter_Square"
                        >
                          <p>{{ $t('Meter_Square') }} </p>
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <div style="display:flex;gap:10px;width:100%;flex-wrap:wrap;">
                      <b-form-group
                        :label="$t('MaterialVariant')"
                        style="width:25%"
                      >
                        <vue-select
                          v-model="material.name"
                          :placeholder="$t('Description')"
                          label="materialVariantName"
                          :options="material.parameter === 'Shirit' ? [] : getMaterialOptions(material.measurementType)"
                          :clearable="material.parameter === 'Shirit' ? false : true"
                          :disabled="material.parameter === 'Shirit' ? true : false"
                          @search="searchMaterial(material.measurementType, $event)"
                          @input="updateMaterialVariantId(material.name, material, window.width, window)"
                        >
                          <li
                            slot="list-footer"
                            class="pagination"
                            style="display: flex; width: 100%; justify-content: center;"
                          >
                            <div
                              v-if="getMaterialVariantColorNameLike.length > 1"
                              style="display:flex;gap:5px; padding-top: 3px;width:98%"
                            >
                              <button
                                class="buttonCancel"
                                type="button"
                                :disabled="pageNumberFilter == 1"
                                @click="previousPage(material.measurementType, searchQuery)"
                              >
                                {{ $t('Previous') }}
                              </button>
                              <button
                                class="buttonSubmit"
                                type="button"
                                @click="nextPage(material.measurementType, searchQuery)"
                              >
                                {{ $t('Next') }}
                              </button>
                            </div>
                          </li>
                        </vue-select>
                        <p
                          v-if="(material.name == null || material.name == '' )&& isButtonSubmited "
                          class="validationClass"
                        >
                          {{ $t('Please Select a material variant') }}
                        </p>
                      </b-form-group>
                      <b-form-group
                        v-if="material.measurementType == 'Part' || material.measurementType == 'Parts'"
                        :label="$t(material.measurementType)"
                      >
                        <div class="input-wrapper">
                          <b-input
                            v-model.number="material.quantity"
                            required
                            min="0"
                            type="number"
                            class="custom-input"
                            @input="calculateTotalPerMeter(material.pricePerMeterWithDiscount, material.quantity, material, window)"
                          />
                          <span class="unitMeter">m</span>
                        </div>

                        <p
                          v-if="(material.quantity < 0 || material.quantity == null || material.quantity == '') && isButtonSubmited"
                          class="validationClass"
                        >
                          {{ $t('TheValue') }}
                        </p>
                      </b-form-group>
                      <b-form-group
                        v-else-if="material.measurementType == 'Meter_Square'"
                      >
                        <div style="display:flex;gap:10px;">
                          <b-form-group
                            :label="$t('Width')"
                          >
                            <div class="input-wrapper">
                              <b-input
                                v-model.number="material.width"
                                required
                                min="0"
                                type="number"
                                class="custom-input"
                                @input="calculateTotalPerMeterSquare(material.pricePerMeterWithDiscount, material.width, material.height, material, window)"
                              />
                              <span class="unitMeter">m</span>
                            </div>

                            <p
                              v-if="(material.width < 0 || material.width == null || material.width == '') && isButtonSubmited"
                              class="validationClass"
                            >
                              {{ $t('TheValue') }}
                            </p>
                          </b-form-group>
                          <b-form-group
                            :label="$t('Height')"
                          >
                            <div class="input-wrapper">
                              <b-input
                                v-model.number="material.height"
                                required
                                min="0"
                                type="number"
                                class="custom-input"
                                @input="calculateTotalPerMeterSquare(material.pricePerMeterWithDiscount, material.width, material.height, material, window)"
                              />
                              <span class="unitMeter">m</span>
                            </div>
                            <p
                              v-if="(material.height < 0 || material.height == null || material.height == '') && isButtonSubmited"
                              class="validationClass"
                            >
                              {{ $t('TheValue') }}
                            </p>
                          </b-form-group>
                        </div>

                      </b-form-group>
                      <b-form-group
                        v-else
                        :label="$t(material.measurementType)"
                      >
                        <div class="input-wrapper">
                          <b-input
                            v-model.number="material.quantity"
                            required
                            min="0"
                            type="number"
                            class="custom-input"
                            @input="calculateTotalPerMeter(material.pricePerMeterWithDiscount, material.quantity, material, window)"
                          />
                          <span class="unitMeter">m</span>
                        </div>
                        <p
                          v-if="(material.quantity < 0 || material.quantity == null || material.quantity == '') && isButtonSubmited"
                          class="validationClass"
                        >
                          {{ $t('TheValue') }}
                        </p>
                      </b-form-group>
                      <b-form-group :label="$t('PurchasePrice')">
                        <div class="input-wrapper">
                          <b-form-input
                            v-model.number="material.purchasePrice"
                            required
                            disabled
                            type="number"
                            class="custom-input"
                          />
                          <span class="unitMeter">€</span>
                        </div>
                      </b-form-group>
                      <b-form-group :label="$t('pricePerMeter')">
                        <div class="input-wrapper">
                          <b-form-input
                            v-model.number="material.pricePerMeter"
                            required
                            disabled
                            type="number"
                            class="custom-input"
                          />
                          <span class="unitMeter">€</span>
                        </div>
                      </b-form-group>
                      <b-form-group
                        :label="$t('PriceDiscount')"
                      >
                        <div class="input-wrapper">
                          <b-input
                            v-model.number="material.pricePerMeterWithDiscount"
                            required
                            min="0"
                            type="number"
                            @input="material.measurementType !== 'Meter_Square' ? calculateTotalPerMeter(material.pricePerMeterWithDiscount, material.quantity || material.quantity, material, window) : calculateTotalPerMeterSquare(material.pricePerMeterWithDiscount, material.width, material.height, material, window)"
                          />
                          <span class="unitMeter">€</span>
                        </div>

                      </b-form-group>
                      <b-form-group
                        :label="$t('TotalPerMeter')"
                      >
                        <div class="input-wrapper">
                          <b-input
                            v-model.number="material.totalPerMeter"
                            disabled
                            type="number"
                          />
                          <span class="unitMeter">€</span>
                        </div>

                      </b-form-group>
                    </div>
                  </div>
                  <button
                    class="buttonNotaSmall"
                    type="button"
                    @click="addMaterialObject(index, window)"
                  >
                    Shto Material
                  </button>
                  <p
                    v-if="window.materialVariantInStoreDtos.length == 0 && isButtonSubmited"
                    class="validationClass"
                  >
                    {{ $t('AddMaterial') }}
                  </p>
                  <div
                    v-for="(windowDecorative, windowDecorativeIndex) in window.createWindowDecorativeRequestDtos"
                    :key="windowDecorativeIndex"
                    class="decorativeWindow"
                  >
                    <div style="display:flex;justify-content: space-between;align-items:center;">
                      <p style="display:flex;gap:10px;align-items:center;margin-bottom: 0px;">
                        <span style="color:#FF274F;font-size: 18px;font-weight:600;"> {{ windowDecorative.name }} </span>
                        <b-icon-plus-circle
                          v-if="window.createWindowDecorativeRequestDtos.findIndex(item => item.hingType === windowDecorative.hingType) === windowDecorativeIndex"
                          style="cursor:pointer;color:green;"
                          @click="addMoreDecorative(window.createWindowDecorativeRequestDtos, windowDecorative.hingType , windowDecorative)"
                        />
                      </p>

                      <b-icon-dash-circle
                        v-if="windowDecorativeIndex !== window.createWindowDecorativeRequestDtos.findIndex(item => item.hingType === windowDecorative.hingType)"
                        style="cursor:pointer;color:red;"
                        @click="removeSomeDecorative(window.createWindowDecorativeRequestDtos, windowDecorativeIndex)"
                      />
                    </div>
                    <div style="display: flex;gap:15px">
                      <b-form-group
                        :label="$t('Height')"
                      >
                        <div class="input-wrapper">
                          <b-form-input
                            v-model.number="windowDecorative.height"
                            :placeholder="$t('Type')"
                            min="0"
                            type="number"
                            class="custom-input"
                          />
                          <span class="unitMeter">m</span>
                        </div>

                        <p
                          v-if="(windowDecorative.height < 0 || windowDecorative.height == null || windowDecorative.height == '')"
                          class="validationClass"
                        >
                          {{ $t('TheValue') }}
                        </p>
                      </b-form-group>
                      <b-form-group
                        :label="$t('Width')"
                      >
                        <div class="input-wrapper">
                          <b-form-input
                            v-model.number="windowDecorative.width"
                            :placeholder="$t('Type')"
                            class="custom-input"
                            min="0"
                            type="number"
                            @input="updateMaterialLengthOrQuantity(windowDecorative)"
                          />
                          <span class="unitMeter">m</span>
                        </div>

                        <p
                          v-if="(windowDecorative.width < 0 || windowDecorative.width == null || windowDecorative.width == '')"

                          class="validationClass"
                        >
                          {{ $t('TheValue') }}
                        </p>
                      </b-form-group>
                      <b-form-group
                        :label="$t('SewingType')"
                        style="width: 25%;"
                      >
                        <vue-select
                          v-model="windowDecorative.sewingType"
                          :options="sewingTypes"
                          label="name"
                          :reduce="(e) => e.value"
                          :placeholder="$t('Select')"
                          @input="handleSewingMethod(windowDecorative)"
                        />
                        <p
                          v-if="windowDecorative.sewingType == null"
                          class="validationClass"
                        >
                          {{ $t('Please select a sewing type') }}
                        </p>
                      </b-form-group>
                    </div>
                    <div
                      v-for="(materialDecorative, materialIndexDecorative) in windowDecorative.materialVariantInStoreDtos"
                      :key="materialIndexDecorative"
                      class="materialsClass"
                    >
                      <div style="display:flex;justify-content: space-between;padding-right: 10px">
                        <label> {{ materialIndexDecorative + 1 }}.{{ $t('MeasurementType') }} <span style="font-weight:600"> {{ materialDecorative.parameter ? `: ${materialDecorative.parameter}`: null }} </span></label>
                        <img
                          v-if="!materialDecorative.parameter"
                          src="../../assets/images/Trash_Full.svg"
                          style="cursor:pointer;"
                          @click="removeMaterialDecorative(index, windowDecorativeIndex, materialIndexDecorative)"
                        >
                      </div>
                      <b-form-group>
                        <b-form-radio-group
                          v-model="materialDecorative.measurementType"
                          :disabled="materialDecorative.parameter === 'Shirit' ? true : false"
                          :class="{'form-radio-disabled': materialDecorative.parameter === 'Shirit'}"
                          style="display:flex;gap: 10px;width:91%"
                          @change="resetMaterialName(materialDecorative, window)"
                        >
                          <b-form-radio
                            class="form-radio"
                            value="Meter"
                          >
                            <p>{{ $t('Meter') }} </p>
                          </b-form-radio>
                          <b-form-radio
                            class="form-radio"
                            value="Part"
                          >
                            <p>{{ $t('Part') }} </p>
                          </b-form-radio>
                          <b-form-radio
                            class="form-radio"
                            value="Verse"
                          >
                            <p>{{ $t('Verse') }} </p>
                          </b-form-radio>
                          <b-form-radio
                            class="form-radio"
                            value="Package"
                          >
                            <p>{{ $t('Package') }} </p>
                          </b-form-radio>
                          <b-form-radio
                            class="form-radio"
                            value="Pair"
                          >
                            <p>{{ $t('Pair') }} </p>
                          </b-form-radio>
                          <b-form-radio
                            class="form-radio"
                            value="Set"
                          >
                            <p>{{ $t('Set') }} </p>
                          </b-form-radio>
                          <b-form-radio
                            class="form-radio"
                            value="Meter_Square"
                          >
                            <p>{{ $t('Meter_Square') }} </p>
                          </b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>
                      <div style="display:flex;gap:10px;width:100%;flex-wrap:wrap;">
                        <b-form-group
                          :label="$t('MaterialVariant')"
                          style="width:25%"
                        >
                          <vue-select
                            v-model="materialDecorative.name"
                            :placeholder="$t('Description')"
                            label="materialVariantName"
                            :options="materialDecorative.parameter === 'Shirit' ? [] : getMaterialOptions(materialDecorative.measurementType)"
                            :clearable="materialDecorative.parameter === 'Shirit' ? false : true"
                            :disabled="materialDecorative.parameter === 'Shirit' ? true : false"
                            @input="updateMaterialVariantId(materialDecorative.name, materialDecorative, window.width, window)"
                            @search="searchMaterial(materialDecorative.measurementType, $event)"
                          >
                            <li
                              slot="list-footer"
                              class="pagination"
                              style="display: flex; width: 100%; justify-content: center;"
                            >
                              <div
                                v-if="getMaterialVariantColorNameLike.length > 1"
                                style="display:flex;gap:5px; padding-top: 3px;width:98%"
                              >
                                <button
                                  class="buttonCancel"
                                  type="button"
                                  :disabled="pageNumberFilter == 1"
                                  @click="previousPage(materialDecorative.measurementType, searchQuery)"
                                >
                                  {{ $t('Previous') }}
                                </button>
                                <button
                                  class="buttonSubmit"
                                  type="button"
                                  @click="nextPage(materialDecorative.measurementType, searchQuery)"
                                >
                                  {{ $t('Next') }}
                                </button>
                              </div>
                            </li>
                          </vue-select>
                          <p
                            v-if="(materialDecorative.name == null || materialDecorative.name == '' )"
                            class="validationClass"
                          >
                            {{ $t('Please Select a material variant') }}
                          </p>
                        </b-form-group>
                        <b-form-group
                          v-if="materialDecorative.measurementType == 'Part' || materialDecorative.measurementType == 'Parts'"
                          :label="$t(materialDecorative.measurementType)"
                        >
                          <div class="input-wrapper">
                            <b-input
                              v-model.number="materialDecorative.quantity"
                              required
                              min="0"
                              type="number"
                              class="custom-input"
                              @input="calculateTotalPerMeter(materialDecorative.pricePerMeterWithDiscount, materialDecorative.quantity, materialDecorative, windowDecorative)"
                            />
                            <span class="unitMeter">m</span>
                          </div>

                          <p
                            v-if="(materialDecorative.quantity < 0 || materialDecorative.quantity == null || materialDecorative.quantity == '')"
                            class="validationClass"
                          >
                            {{ $t('TheValue') }}
                          </p>
                        </b-form-group>
                        <b-form-group
                          v-else-if="materialDecorative.measurementType == 'Meter_Square'"
                        >
                          <div style="display:flex;gap:10px;">
                            <b-form-group
                              :label="$t('Width')"
                            >
                              <div class="input-wrapper">
                                <b-input
                                  v-model.number="materialDecorative.width"
                                  required
                                  min="0"
                                  type="number"
                                  class="custom-input"
                                  @input="calculateTotalPerMeterSquare(materialDecorative.pricePerMeterWithDiscount, materialDecorative.width, materialDecorative.height, materialDecorative, windowDecorative)"
                                />
                                <span class="unitMeter">m</span>
                              </div>

                              <p
                                v-if="(materialDecorative.width < 0 || materialDecorative.width == null || materialDecorative.width == '') && isButtonSubmited "
                                class="validationClass"
                              >
                                {{ $t('TheValue') }}
                              </p>
                            </b-form-group>
                            <b-form-group
                              :label="$t('Height')"
                            >
                              <div class="input-wrapper">
                                <b-input
                                  v-model.number="materialDecorative.height"
                                  required
                                  min="0"
                                  type="number"
                                  class="custom-input"
                                  @input="calculateTotalPerMeterSquare(materialDecorative.pricePerMeterWithDiscount, materialDecorative.width, materialDecorative.height, materialDecorative, windowDecorative)"
                                />
                                <span class="unitMeter">m</span>
                              </div>

                              <p
                                v-if="(materialDecorative.height < 0 || materialDecorative.height == null || materialDecorative.height == '')"
                                class="validationClass"
                              >
                                {{ $t('TheValue') }}
                              </p>
                            </b-form-group>
                          </div>

                        </b-form-group>
                        <b-form-group
                          v-else
                          :label="$t(materialDecorative.measurementType)"
                        >
                          <div class="input-wrapper">
                            <b-input
                              v-model.number="materialDecorative.quantity"
                              required
                              min="0"
                              type="number"
                              class="custom-input"
                              @input="calculateTotalPerMeter(materialDecorative.pricePerMeterWithDiscount, materialDecorative.quantity, materialDecorative, windowDecorative)"
                            />
                            <span class="unitMeter">m</span>
                          </div>

                          <p
                            v-if="(materialDecorative.quantity < 0 || materialDecorative.quantity == null || materialDecorative.quantity == '')"
                            class="validationClass"
                          >
                            {{ $t('TheValue') }}
                          </p>
                        </b-form-group>
                        <b-form-group :label="$t('PurchasePrice')">
                          <div class="input-wrapper">
                            <b-form-input
                              v-model.number="materialDecorative.purchasePrice"
                              required
                              disabled
                              type="number"
                              class="custom-input"
                            />
                            <span class="unitMeter">€</span>
                          </div>
                        </b-form-group>
                        <b-form-group
                          :label="$t('pricePerMeter')"
                        >
                          <div class="input-wrapper">
                            <b-input
                              v-model.number="materialDecorative.pricePerMeter"
                              required
                              disabled
                              min="0"
                              type="number"
                              class="custom-input"
                            />
                            <span class="unitMeter">€</span>
                          </div>

                        </b-form-group>
                        <b-form-group
                          :label="$t('PriceDiscount')"
                        >
                          <div class="input-wrapper">
                            <b-input
                              v-model.number="materialDecorative.pricePerMeterWithDiscount"
                              required
                              min="0"
                              type="number"
                              class="custom-input"
                              @input="materialDecorative.measurementType !== 'Meter_Square' ? calculateTotalPerMeter(materialDecorative.pricePerMeterWithDiscount, materialDecorative.quantity || materialDecorative.quantity, materialDecorative, windowDecorative) : calculateTotalPerMeterSquare(materialDecorative.pricePerMeterWithDiscount, materialDecorative.width, materialDecorative.height, materialDecorative, windowDecorative) "
                            />
                            <span class="unitMeter">€</span>
                          </div>

                        </b-form-group>
                        <b-form-group
                          :label="$t('TotalPerMeter')"
                        >
                          <div class="input-wrapper">
                            <b-input
                              v-model.number="materialDecorative.totalPerMeter"
                              disabled
                              class="custom-input"
                              type="number"
                            />
                            <span class="unitMeter">€</span>
                          </div>

                        </b-form-group>
                      </div>
                    </div>
                    <div style="margin-top: 10px">
                      <button
                        v-if="window.createWindowDecorativeRequestDtos.length > 0"
                        class="buttonNotaSmall"
                        type="button"
                        @click="addMaterialObjectDecorative(index, window, windowDecorativeIndex)"
                      >
                        Shto Material
                      </button>
                    </div>
                    <p
                      v-if="windowDecorative.materialVariantInStoreDtos.length == 0"
                      class="validationClass"
                    >
                      {{ $t('AddMaterial') }}
                    </p>
                  </div>
                </div>
              </div>
            </b-collapse>
            <div
              v-if="item.createFloorRequestDtos[selectedFloorIndex]?.createRoomRequestDtos[selectedRoomIndex]?.createWindowRequestDtos.length > 0"
              class="buttonsCollapsed"
            >
              <b-button
                variant="link"
                class="collapse-button"
                @click="toggleCollapseObjectMaterials(index)"
              >
                <b-icon-chevron-down v-if="!isCollapsedObjectMaterials(index)" />
                <b-icon-chevron-up v-if="isCollapsedObjectMaterials(index)" />
              </b-button>
            </div>
          </div>
        </div>
      </b-collapse>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    // DatePicker,
  },
  props: ['createHouseItemRequestDtos', 'isButtonSubmited'],
  data() {
    return {
      totalPerMeter: 0,
      pageNumberFilter: 1,
      selectedFloorIndex: 0,
      selectedRoomIndex: 0,
      selectedWindowIndex: 0,
      collapsedStates: {},
      collapsedStatesFloor: {},
      collapsedStatesRoom: {},
      collapsedStatesObject: {},
      collapsedStatesObjectMaterials: {},
      garnishtetList: [
        '68185BD0-D3F3-4DB3-5700-08DD5066E9DC',
        'ABD778C9-FD1C-42F2-5701-08DD5066E9DC',
        '8D403E9E-2533-485B-5720-08DD5066E9DC',
        'E041E223-EE18-44AD-5721-08DD5066E9DC',
        '1C9E95AD-2F23-400C-5724-08DD5066E9DC',
        'BFB47B43-37C6-4578-5722-08DD5066E9DC',
        '76F48E2E-0F4B-4F24-5702-08DD5066E9DC',
        '1AC0A40B-001C-472C-5717-08DD5066E9DC',
        'BDFA4B85-1640-429F-5723-08DD5066E9DC',
        'A6D5FE37-BAAC-4A9C-571D-08DD5066E9DC',
        '2271151F-E292-4ED3-571E-08DD5066E9DC',
        'B0638802-4593-40D4-5718-08DD5066E9DC',
        '93AC41C5-CF56-4E14-571B-08DD5066E9DC',
        '1FC0A5E1-E883-47BD-5719-08DD5066E9DC',
        '922F1CB2-E7C1-4CDA-571C-08DD5066E9DC',
        '472D1F46-F1F7-4ECA-571A-08DD5066E9DC',
        '6E7086C5-D62C-41E3-570E-08DD5066E9DC',
        '4F20F7B4-2C95-4C7E-570F-08DD5066E9DC',
        '7192361F-5C38-49AC-5725-08DD5066E9DC',
        '36358D19-D640-488A-571F-08DD5066E9DC',
        '8BC78B87-2606-40CB-5716-08DD5066E9DC',
        'C8420E96-474E-4CA1-5715-08DD5066E9DC',
        '0A15402D-4149-4C84-5711-08DD5066E9DC',
        '5859A871-EEAA-4E8C-5710-08DD5066E9DC',
        'B3B61979-D222-41DE-5712-08DD5066E9DC',
        'D5254827-D181-40E3-5713-08DD5066E9DC',
        'EC9A06AC-9676-4699-5714-08DD5066E9DC',
      ],
      hingeTypes: [
        { name: this.$t('Decorative'), value: 'Decorative' },
        { name: this.$t('Closed'), value: 'Closed' },
      ],
      sewingTypes: [
        {
          name: 'Sistemi Amerikan 3m', value: 'American_3m', meter: 3, materialVariantId: 'cd9e5ed2-df10-4ba4-a6db-08dd09677ee2', materialVariantName: 'Shiritat Amerikan',
        },
        {
          name: 'Sistemi Amerikan 2.8m', value: 'American_2_8m', meter: 2.8, materialVariantId: 'cd9e5ed2-df10-4ba4-a6db-08dd09677ee2', materialVariantName: 'Shiritat Amerikan',
        },
        {
          name: 'Fallta te rregullta 3m', value: 'FalltaReglar_3m', meter: 3, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Fallta te rregullta 2.5m', value: 'FalltaReglar_2_5m', meter: 2.5, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Fallta te rregullta 2m', value: 'FalltaReglar_2m', meter: 2, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Fallta Zvicrrane 3m', value: 'FalltaSwiss_3m', meter: 3, materialVariantId: '12f0c104-a95a-47c8-a6dc-08dd09677ee2', materialVariantName: 'Shiritat Zvicerran',
        },
        {
          name: 'Fallta Zvicrrane 2.7m', value: 'FalltaSwiss_2_7m', meter: 2.7, materialVariantId: '12f0c104-a95a-47c8-a6dc-08dd09677ee2', materialVariantName: 'Shiritat Zvicerran',
        },
        {
          name: 'Fallta Zvicrrane 2m', value: 'FalltaSwiss_2_5m', meter: 2.5, materialVariantId: '12f0c104-a95a-47c8-a6dc-08dd09677ee2', materialVariantName: 'Shiritat Zvicerran',
        },
        {
          name: 'Qepje me vega 2.5m', value: 'Veg_2_5m', meter: 2.5, materialVariantId: '70ff128e-c889-424a-a6ed-08dd09677ee2', materialVariantName: 'Shirita me vega',
        },
        {
          name: 'Qepje Fallta me vrime 3m', value: 'Holes_3m', meter: 3, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Qepje Fallta me vrime 2.5m', value: 'Holes_2_5m', meter: 2.5, materialVariantId: 'dea85c63-6242-4010-a6ee-08dd09677ee2', materialVariantName: 'Shirita Fallta',
        },
        {
          name: 'Qepje me rrudhje 4m', value: 'Wrinkle_4m', meter: 4, materialVariantId: 'f4ad44f0-55f5-476c-a6ef-08dd09677ee2', materialVariantName: 'Shirita me rrudha',
        },
        {
          name: 'Qepje me rrudhje 3m', value: 'Wrinkle_3m', meter: 3, materialVariantId: 'f4ad44f0-55f5-476c-a6ef-08dd09677ee2', materialVariantName: 'Shirita me rrudha',
        },
        {
          name: 'Qepje shirit drejt', value: 'StraightBand', meter: 1, materialVariantId: '0974f5ce-e07e-4ac0-a6f0-08dd09677ee2', materialVariantName: 'Shirita drejt',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getMaterialsByArticleNum',
      'getMaterialVariantColorNameLike',
      'getMaterialsVByMeter',
      'getMaterialsVByPart',
      'getMaterialsVByPackage',
      'getMaterialsVBySet',
      'getMaterialsVByPair',
      'getMaterialsVByVerse',
      'getMaterialsVByVMeter_Square',
      'getSellPriceByVariant',
      'getLoggedInUser',
    ]),
  },
  mounted() {
  },
  methods: {
    ...mapActions(['filterVariantByColor', 'loadPriceByVariant', 'resetAllFiltered']),
    removeSomeDecorative(decorative, index) {
      decorative.splice(index, 1);
    },
    addMoreDecorative(window, hingtype, windowDecorative) {
      const existingCount = window.filter((item) => { return item.hingType === hingtype }).length;
      const newName = `${windowDecorative.name} ${existingCount + 1}`;
      window.push({
        name: newName,
        width: windowDecorative.width,
        height: windowDecorative.height,
        sewingType: null,
        hingType: hingtype,
        orderOtherService: {
          pattern: true,
          sewing: true,
          transport: true,
          montage: true,
        },
        materialVariantInStoreDtos: [
          {
            materialVariantId: null,
            name: null,
            measurementType: 'Meter',
            quantity: 0,
            length: 0,
            pricePerMeter: 0,
            pricePerMeterWithDiscount: 0,
            purchasePrice: 0,
            totalPerMeter: 0,
          },
        ],
        montageStart: null,
        montageEnd: null,
      });

      console.log('window', window);
      console.log('hingtype', hingtype);
    },
    updateWindowDecorativeWidth(value) {
      if (value.createWindowDecorativeRequestDtos && value.createWindowDecorativeRequestDtos.length > 0) {
        value.createWindowDecorativeRequestDtos.forEach((item) => {
          item.width = value.width;
        });
      }
    },
    updateWindowDecorativeHeight(value) {
      if (value.createWindowDecorativeRequestDtos && value.createWindowDecorativeRequestDtos.length > 0) {
        value.createWindowDecorativeRequestDtos.forEach((item) => {
          item.height = value.height;
        });
      }
    },
    updateMaterialVariantId(value, material, width, window) {
      console.log('material', material)
      if (value != null) {
        material.materialVariantId = value.materialVariantId
        material.pricePerMeter = value.sellPrice || 0
        material.name = value.materialVariantName
        material.pricePerMeterWithDiscount = value.sellPrice || 0
        material.purchasePrice = value.pricePerMeter || 0
        if (material.measurementType !== 'Meter_Square') {
          material.totalPerMeter = ((value.sellPrice || 0) * (material.quantity || material.quantity || 0)).toFixed(2)
        } else {
          material.totalPerMeter = ((value.sellPrice || 0) * Math.ceil(material.width || 0) * Math.ceil(material.height || 0)).toFixed(2)
        }
        if (this.garnishtetList.map((id) => { return id.toLowerCase() }).includes(value.materialVariantId.toLowerCase())) {
          material.quantity = width?.toFixed(2);
        }
      } else {
        material.materialVariantId = null
        material.pricePerMeter = 0
        material.pricePerMeterWithDiscount = 0
        material.name = null
        material.totalPerMeter = 0
        material.purchasePrice = 0
      }
      this.handleSewingMethod(window)
    },
    checkMontage(value, window) {
      if (value == false) {
        window.montageStart = null
        window.montageEnd = null
      }
    },
    updateDecorativeName(index, window) {
      const windowDecorativeArray = this.createHouseItemRequestDtos[index]
        .createFloorRequestDtos[this.selectedFloorIndex]
        .createRoomRequestDtos[this.selectedRoomIndex]
        .createWindowRequestDtos[this.selectedWindowIndex]
        .createWindowDecorativeRequestDtos;

      windowDecorativeArray.forEach((decorativeObj) => {
        if (decorativeObj.hingType) {
          decorativeObj.name = `${window.name} - ${decorativeObj.hingType}`;
        }
      });
    },
    updateDecorative(index, window, hingeTypeValues) {
      const selectedHingeType = hingeTypeValues[hingeTypeValues.length - 1];

      const windowDecoratives = this.createHouseItemRequestDtos[index]
        .createFloorRequestDtos[this.selectedFloorIndex]
        .createRoomRequestDtos[this.selectedRoomIndex]
        .createWindowRequestDtos[this.selectedWindowIndex]
        .createWindowDecorativeRequestDtos;
      if (window.hingType && window.hingType.length > 0) {
        window.hingType.forEach((hingeType) => {
          const existingItem = windowDecoratives.find((item) => {
            return item.name.includes(window.name.split(' - ')[0]) && item.name.includes(hingeType);
          });

          if (!existingItem) {
            windowDecoratives.push({
              name: `${window.name} - ${selectedHingeType}`,
              width: window.width,
              height: window.height,
              sewingType: null,
              orderOtherService: {
                pattern: true,
                sewing: true,
                transport: true,
                montage: true,
              },
              materialVariantInStoreDtos: [
                {
                  materialVariantId: null,
                  name: null,
                  measurementType: 'Meter',
                  quantity: 0,
                  length: 0,
                  pricePerMeter: 0,
                  pricePerMeterWithDiscount: 0,
                  purchasePrice: 0,
                  totalPerMeter: 0,
                  width: 0,
                  height: 0,
                },
              ],
              montageStart: null,
              montageEnd: null,
              hingType: selectedHingeType,
            });
          }
        });

        windowDecoratives.forEach((decorativeItem, idx) => {
          const shouldRemove = !window.hingType.some((hingeType) => { return decorativeItem.name.includes(hingeType) });
          if (shouldRemove) {
            windowDecoratives.splice(idx, 1);
          }
        });
      } else {
        this.createHouseItemRequestDtos[index]
          .createFloorRequestDtos[this.selectedFloorIndex]
          .createRoomRequestDtos[this.selectedRoomIndex]
          .createWindowRequestDtos[this.selectedWindowIndex]
          .createWindowDecorativeRequestDtos = [];
      }
    },
    toggleEditWindowName(index, floorIndex, roomIndex, windowIndex, window) {
      this.$set(this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos[roomIndex].createWindowRequestDtos, windowIndex, {
        ...this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos[roomIndex].createWindowRequestDtos[windowIndex],
        editable: !this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos[roomIndex].createWindowRequestDtos[windowIndex].editable,
      });
      if (window.hingType) {
        this.updateDecorativeName(index, window)
      }
    },
    saveWindowName(index, floorIndex, roomIndex, windowIndex, window) {
      this.$set(this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos[roomIndex].createWindowRequestDtos, windowIndex, {
        ...this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos[roomIndex].createWindowRequestDtos[windowIndex],
        editable: false,
      });
      if (window.hingType) {
        this.updateDecorativeName(index, window)
      }
    },
    saveHouseName(index) {
      this.createHouseItemRequestDtos[index].editable = false;
    },
    toggleEditHouseName(index) {
      this.createHouseItemRequestDtos[index].editable = !this.createHouseItemRequestDtos[index].editable;
    },
    toggleEditFloorName(index, floorIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].editable = !this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].editable;
    },
    saveFloorName(index, floorIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].editable = false;
    },
    toggleEditRoomName(index, floorIndex, roomIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos[roomIndex].editable = !this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos[roomIndex].editable;
    },
    saveRoomName(index, floorIndex, roomIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos[roomIndex].editable = false;
    },
    handleSewingMethod(window) {
      this.updateMaterialLengthOrQuantity(window)
      this.updateMaterialAmerican(window)
    },
    updateMaterialAmerican(window) {
      if (window.sewingType) {
        const selectedSewingType = this.sewingTypes.find(
          (type) => { return type.value === window.sewingType },
        );
        this.loadPriceByVariant({
          materialVariantId: selectedSewingType.materialVariantId,
        }).then((response) => {
          const existingItemIndex = window.materialVariantInStoreDtos.findIndex(
            (item) => { return item.parameter === 'Shirit' },
          );

          if (existingItemIndex !== -1) {
            window.materialVariantInStoreDtos[existingItemIndex] = {
              materialVariantId: selectedSewingType.materialVariantId,
              name: selectedSewingType.materialVariantName,
              measurementType: 'Meter',
              quantity: 0,
              length: (selectedSewingType.meter * (window.width || 0) + 0.1)?.toFixed(2),
              pricePerMeter: response,
              pricePerMeterWithDiscount: response,
              parameter: 'Shirit',
              totalPerMeter: (response * (selectedSewingType.meter * (window.width || 0) + 0.1))?.toFixed(2),
              purchasePrice: response,

            };
          } else {
            window.materialVariantInStoreDtos.unshift({
              materialVariantId: selectedSewingType.materialVariantId,
              name: selectedSewingType.materialVariantName,
              measurementType: 'Meter',
              quantity: 0,
              length: (selectedSewingType.meter * (window.width || 0) + 0.1)?.toFixed(2),
              pricePerMeter: response,
              pricePerMeterWithDiscount: response,
              parameter: 'Shirit',
              totalPerMeter: (response * (selectedSewingType.meter * (window.width || 0) + 0.1))?.toFixed(2),
              purchasePrice: response,
            });
          }
        }).catch((error) => {
          console.error('Error loading price:', error);
        });
      } else {
        window.materialVariantInStoreDtos = window.materialVariantInStoreDtos.filter(
          (item) => { return item.parameter !== 'Shirit' },
        );
      }
    },
    updateMaterialLengthOrQuantity(window) {
      if (!window.sewingType || window.width == null || window.width === '') {
        window.materialVariantInStoreDtos.forEach((material) => {
          if (material.measurementType === 'Part') {
            material.quantity = 0;
          } else {
            material.quantity = 0;
          }
        });
      }

      const selectedSewingType = this.sewingTypes.find(
        (type) => { return type.value === window.sewingType; },
      );

      if (selectedSewingType) {
        const meter = selectedSewingType.meter ?? 0;
        const width = window.width ?? 0;
        const calculatedValue = meter * width;

        window.materialVariantInStoreDtos.forEach((material) => {
          const materialId = material.materialVariantId ? material.materialVariantId.toLowerCase() : null;

          if (this.garnishtetList.map((id) => { return id.toLowerCase() }).includes(materialId)) {
            if (material.measurementType === 'Part') {
              material.quantity = Math.ceil(width)?.toFixed(2);
              material.totalPerMeter = ((material.quantity) * material.pricePerMeterWithDiscount)?.toFixed(2);
            } else if (material.measurementType === 'Meter_Square') {
              material.quantity = 0;
              material.totalPerMeter = ((material.pricePerMeterWithDiscount || 0) * Math.ceil(material.width || 0) * Math.ceil(material.height || 0)).toFixed(2)
            } else {
              material.quantity = Math.ceil(width)?.toFixed(2);
              material.totalPerMeter = ((material.quantity) * material.pricePerMeterWithDiscount)?.toFixed(2);
            }
          } else if (material.measurementType === 'Part') {
            material.quantity = (calculatedValue + 0.1)?.toFixed(2);
            material.totalPerMeter = ((calculatedValue + 0.1)?.toFixed(2) * material.pricePerMeterWithDiscount)?.toFixed(2);
          } else if (material.measurementType === 'Meter_Square') {
            material.quantity = 0;
            material.totalPerMeter = ((material.pricePerMeterWithDiscount || 0) * Math.ceil(material.width || 0) * Math.ceil(material.height || 0)).toFixed(2)
          } else {
            material.quantity = (calculatedValue + 0.1)?.toFixed(2);
            material.totalPerMeter = ((calculatedValue + 0.1)?.toFixed(2) * material.pricePerMeterWithDiscount)?.toFixed(2);
          }
        });
      } else {
        const width = window.width ?? 0;

        window.materialVariantInStoreDtos.forEach((material) => {
          const materialId = material.materialVariantId ? material.materialVariantId.toLowerCase() : null;

          if (this.garnishtetList.map((id) => { return id.toLowerCase() }).includes(materialId)) {
            if (material.measurementType === 'Part') {
              material.quantity = Math.ceil(width)?.toFixed(2);
              material.totalPerMeter = ((material.quantity) * material.pricePerMeterWithDiscount)?.toFixed(2);
            } else if (material.measurementType === 'Meter_Square') {
              material.quantity = 0;
              material.totalPerMeter = ((material.pricePerMeterWithDiscount || 0) * Math.ceil(material.width || 0) * Math.ceil(material.height || 0)).toFixed(2)
            } else {
              material.quantity = Math.ceil(width)?.toFixed(2);
              material.totalPerMeter = ((material.quantity) * material.pricePerMeterWithDiscount)?.toFixed(2);
            }
          } else if (material.measurementType === 'Part') {
            material.quantity = (width + 0.1)?.toFixed(2);
            material.totalPerMeter = ((width + 0.1)?.toFixed(2) * material.pricePerMeterWithDiscount)?.toFixed(2);
          } else if (material.measurementType === 'Meter_Square') {
            material.quantity = 0;
            material.totalPerMeter = ((material.pricePerMeterWithDiscount || 0) * Math.ceil(material.width || 0) * Math.ceil(material.height || 0)).toFixed(2)
          } else {
            material.quantity = (width + 0.1)?.toFixed(2);
            material.totalPerMeter = ((width + 0.1)?.toFixed(2) * material.pricePerMeterWithDiscount)?.toFixed(2);
          }
        });
      }
    },
    calculateTotalPerMeter(price, length, material, window) {
      this.totalPerMeter = price * length
      material.totalPerMeter = (price * length).toFixed(2)
      setTimeout(() => {
        if ((material.quantity || material.quantity) == '' || (material.quantity || material.quantity) < 0) {
          this.updateMaterialLengthOrQuantity(window);
        }
      }, 3000);
    },
    calculateTotalPerMeterSquare(price, width, height, material) {
      material.totalPerMeter = ((price || 0) * Math.ceil(width || 0) * Math.ceil(height || 0)).toFixed(2)
    },
    resetMaterialName(material, window) {
      material.name = null;
      material.pricePerMeter = 0;
      material.pricePerMeterWithDiscount = 0;
      material.purchasePrice = 0;
      material.width = 0;
      material.height = 0;
      if (material.measurementType == 'Meter_Square') {
        material.quantity = 0
      }
      this.resetAllFiltered();
      this.updateMaterialLengthOrQuantity(window);
    },
    nextPage(measurement, query) {
      this.pageNumberFilter += 1
      this.filterVariantByColor({
        name: query,
        measurementType: measurement,
        pageNumber: this.pageNumberFilter,
        pageSize: 15,
      });
    },
    previousPage(measurement, query) {
      this.pageNumberFilter -= 1
      this.filterVariantByColor({
        name: query,
        measurementType: measurement,
        pageNumber: this.pageNumberFilter,
        pageSize: 15,
      });
    },
    searchMaterial(measurement, query) {
      this.searchQuery = query
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        this.filterVariantByColor({
          name: query,
          measurementType: measurement,
          pageNumber: 1,
          pageSize: 15,
        });
      }, 500);
    },
    getMaterialOptions(measurementType) {
      let measurement
      if (this.getMaterialVariantColorNameLike.length > 0) {
        measurement = this.getMaterialVariantColorNameLike
      } else if (measurementType === 'Meter') {
        measurement = this.getMaterialsVByMeter;
      } else if (measurementType === 'Package') {
        measurement = this.getMaterialsVByPackage;
      } else if (measurementType === 'Set') {
        measurement = this.getMaterialsVBySet;
      } else if (measurementType === 'Pair') {
        measurement = this.getMaterialsVByPair;
      } else if (measurementType === 'Verse') {
        measurement = this.getMaterialsVByVerse;
      } else if (measurementType === 'Meter_Square') {
        measurement = this.getMaterialsVByVMeter_Square;
      } else {
        measurement = this.getMaterialsVByPart;
      }


      return measurement;
    },
    addFloor(index) {
      const newFloor = this.createHouseItemRequestDtos[index].createFloorRequestDtos.length + 1;
      this.createHouseItemRequestDtos[index].createFloorRequestDtos.push({ name: `Kati nr ${newFloor}`, createRoomRequestDtos: [], editable: false });
    },
    removeHouse(index) {
      this.createHouseItemRequestDtos.splice(index, 1);
    },
    removeFloor(index, floorIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos.splice(floorIndex, 1);
      this.selectedFloorIndex = 0;
      this.selectedRoomIndex = 0;
      this.selectedWindowIndex = 0
    },
    removeMaterial(index, materialIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[this.selectedFloorIndex].createRoomRequestDtos[this.selectedRoomIndex].createWindowRequestDtos[this.selectedWindowIndex].materialVariantInStoreDtos.splice(materialIndex, 1)
    },
    removeMaterialDecorative(index, windowDecorativeIndex, materialIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[this.selectedFloorIndex].createRoomRequestDtos[this.selectedRoomIndex].createWindowRequestDtos[this.selectedWindowIndex].createWindowDecorativeRequestDtos[windowDecorativeIndex].materialVariantInStoreDtos.splice(materialIndex, 1)
    },
    selectFloorToAddRoom(index, floorIndex) {
      this.selectedFloorIndex = floorIndex;
      this.selectedRoomIndex = 0;
      this.selectedWindowIndex = 0;
    },
    selectRoomToAddObject(index, floorIndex, roomIndex) {
      this.selectedRoomIndex = roomIndex;
      this.selectedWindowIndex = 0;
    },
    selectWindowToObject(index, floorIndex, roomIndex, windowIndex) {
      this.selectedWindowIndex = windowIndex;
    },
    addRoom(index) {
      const newRoom = this.createHouseItemRequestDtos[index].createFloorRequestDtos[this.selectedFloorIndex].createRoomRequestDtos.length + 1;
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[this.selectedFloorIndex].createRoomRequestDtos.push({ name: `Dhoma nr ${newRoom}`, createWindowRequestDtos: [], editable: false });
    },
    removeRoom(index, floorIndex, roomIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos.splice(roomIndex, 1);
      this.selectedFloorIndex = 0;
      this.selectedRoomIndex = 0;
      this.selectedWindowIndex = 0;
    },
    removeWindow(index, floorIndex, roomIndex, windowIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[floorIndex].createRoomRequestDtos[roomIndex].createWindowRequestDtos.splice(windowIndex, 1);
      this.selectedFloorIndex = 0;
      this.selectedRoomIndex = 0;
      this.selectedWindowIndex = 0;
    },
    addWindow(index) {
      const newWindow = this.createHouseItemRequestDtos[index].createFloorRequestDtos[this.selectedFloorIndex].createRoomRequestDtos[this.selectedRoomIndex].createWindowRequestDtos.length + 1;
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[this.selectedFloorIndex].createRoomRequestDtos[this.selectedRoomIndex].createWindowRequestDtos.push({
        name: `Pozicioni nr ${newWindow}`,
        width: 0,
        height: 0,
        sewingType: null,
        hingType: null,
        orderOtherService: {
          pattern: true,
          sewing: true,
          transport: true,
          montage: true,
        },
        materialVariantInStoreDtos: [
          {
            materialVariantId: null,
            name: null,
            measurementType: 'Meter',
            quantity: 0,
            length: 0,
            pricePerMeter: 0,
            pricePerMeterWithDiscount: 0,
            purchasePrice: 0,
            totalPerMeter: 0,
          },
        ],
        montageStart: null,
        montageEnd: null,
        createWindowDecorativeRequestDtos: [],
      });
    },
    addMaterialObject(index, window) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[this.selectedFloorIndex].createRoomRequestDtos[this.selectedRoomIndex].createWindowRequestDtos[this.selectedWindowIndex].materialVariantInStoreDtos.push({
        materialVariantId: null,
        name: null,
        measurementType: 'Meter',
        quantity: 0,
        length: 0,
        pricePerMeter: 0,
        pricePerMeterWithDiscount: 0,
        purchasePrice: 0,
        totalPerMeter: 0,
        width: 0,
        height: 0,
      });
      this.handleSewingMethod(window)
    },
    addMaterialObjectDecorative(index, window, windowDecorativeIndex) {
      this.createHouseItemRequestDtos[index].createFloorRequestDtos[this.selectedFloorIndex].createRoomRequestDtos[this.selectedRoomIndex].createWindowRequestDtos[this.selectedWindowIndex].createWindowDecorativeRequestDtos[windowDecorativeIndex].materialVariantInStoreDtos.push({
        materialVariantId: null,
        name: null,
        measurementType: 'Meter',
        quantity: 0,
        length: 0,
        pricePerMeter: 0,
        pricePerMeterWithDiscount: 0,
        purchasePrice: 0,
        totalPerMeter: 0,
        width: 0,
        height: 0,
      });
      this.handleSewingMethod(window)
    },
    toggleCollapse(index) {
      this.$set(this.collapsedStates, index, !this.collapsedStates[index]);
    },
    isCollapsed(index) {
      return !!this.collapsedStates[index];
    },
    toggleCollapseFloor(index) {
      this.$set(this.collapsedStatesFloor, index, !this.collapsedStatesFloor[index]);
    },
    isCollapsedFloor(index) {
      return !!this.collapsedStatesFloor[index];
    },
    toggleCollapseRoom(index) {
      this.$set(this.collapsedStatesRoom, index, !this.collapsedStatesRoom[index]);
    },
    isCollapsedRoom(index) {
      return !!this.collapsedStatesRoom[index];
    },
    toggleCollapseObject(index) {
      this.$set(this.collapsedStatesObject, index, !this.collapsedStatesObject[index]);
    },
    isCollapsedObject(index) {
      return !!this.collapsedStatesObject[index];
    },
    toggleCollapseObjectMaterials(index) {
      this.$set(this.collapsedStatesObjectMaterials, index, !this.collapsedStatesObjectMaterials[index]);
    },
    isCollapsedObjectMaterials(index) {
      return !!this.collapsedStatesObjectMaterials[index];
    },
  },
}
</script>

    <style scoped>
  .input-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .custom-input {
    padding-right: 35px;
    width: 100%;
  }

  .unitMeter {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #475467;
    font-size: 14px;
    pointer-events: none;
  }
    label {
      font-weight: 500;
    }
    .col-form-label {
      font-weight: 500 !important;
  }
    .validationClass{
      color: red;
      padding-top: 5px;
      margin-bottom: 0px;
    }
    .materialsClass{
      display:flex;
      flex-direction: column;
      gap:15px;
    }
    .allMaterialsDetails{
      display:flex;
      flex-direction: column;
      gap:15px;
      margin-top: 15px;
    }
    .allClases {
    display:flex;
    gap:15px;
    flex-wrap:wrap;
    }
    .form-radio{
      display:flex;
      align-items: center;
      gap:8px;
      width:100%;
    }
    .form-radio p {
      margin-bottom: 0px;
      font-size: 14px;
      color:#101828;
      cursor:pointer;
    }
    .orderOtherServiceClass{
      display:flex;
      gap:3px;
      width:100%
    }
    .nameFloor{
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .iconsFloor{
        width:100%;
        display:flex;
        padding: 5px 5px 0px 5px;
        justify-content: space-between;
    }

  .decorativeWindow{
    display:flex;
    flex-direction:column;
    gap:10px;
    border:1px solid lightgrey;
    border-radius:12px;
    padding:10px;
  }

    .sectionClass{
        border: 1px solid lightgrey;
        padding: 10px;
        border-radius: 12px;
        margin-top:10px;
    }

    .hrClass{
        color:gray;
    }

    .iconsClass{
        display:flex;
        gap:10px;
        align-items:center;
    }
  .ordersService{
    display:flex;
        gap:10px;
        align-items:center;
        width:100%
  }
    .homeEdit{
        display:flex;
        gap:5px;
        justify-content: space-between;
    }

    .homeName{
        display:flex;
        gap:5px;
        width:15%;
        align-items:center;
    }

    .floorWrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .objectsClass, .selectedFloor, .buttonNota {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 12px;
    padding: 3px;
    width: 117px;
    min-height: 117px;
    height: 100%;
    font-size:14px !important;
  }

  .objectsClass {
    border: 1px solid lightgrey;
    color: black;
  }

  .selectedFloor {
    border: 2px solid red;
  }

    .collapse-button {
      padding: 0;
      color:black;
    }
    .houseDetail{
      display:flex;
      flex-direction: column;
      gap:10px;
    }
    .buttonsCollapsed{
      display:flex;
      justify-content:flex-end;
      align-items:flex-start;
    }
    .buttonAndCollapse{
      display:flex;
      justify-content: space-between
    }
    .buttonOnly{
      display: flex;
      justify-content: space-between
    }
    </style>
